<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="Tactical Devices" :HeaderGlobalBreadcrumb="breadcrumb").py-4

        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Spread Of Tactical Devices 

                    .header-cta
                        button.btn.btn-primary-o(
                            type='button'
                            v-on:click="popupShow = !popupShow; textFocus('find-device-input');"
                        ) Find Device
            .box__body
                .tactical-user
                    template(v-if="Object.keys(device_selected).length > 0")
                        .p-4.flex.items-center.justify-between.w-full.border-t
                            .block
                                | Found the device -  
                                strong {{ device_selected.name }}
                            button.btn-default.btn-small(@click="setEmptyDevice" v-tooltip="'Remove device'")
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                span.block.ml-2.m-hide Remove this device

                .draw-area.w-full(style="height:600px")
                    .block.box-map(v-if="load_data_status_tactical_devices_map_location === 'loading'")
                        Loading(show="true")

                    //- .block.box-map.bg-gray-200(v-else)
                    template(v-else)
                    
                        //- template(v-if="territory_virtual_detail_map_history.data && territory_virtual_detail_map_history.data.length > 0 && mapHistoryLoaded")
                        template(v-if="mapLoaded")

                            l-map(v-if="vendorMap==='osm'"  ref="mapRefOSM" :id="idOsm" :zoom="10" :center="center" :options="options" style="height: 100%;width: 100%;")
                                l-tile-layer(:url="url" :attribution="attribution")
                                l-marker(v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index")
                                    l-popup(:content="location.name")

                            gmap-map(v-else ref="mapRef" :center="center" :zoom="11" :options="options" style="width:100%; height: 100%;")
                        
                        .block.box-map(v-else)
                            NoDataAvailable
        //- find devices
        section(v-bind:class="{ 'section-popup--show' : popupShow}").section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center
            .section-popup__container
                .box
                    .box__header.no-border
                        header.flex.items-center.justify-between
                            .header-meta
                                h2.subheading Find Device
                            .header-cta
                                button.btn-icon.btn-icon-40(v-on:click="popupShow = !popupShow")
                                    .icon-btn
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    .box__body.p-4(style="min-height:200px")
                        .flex
                            .field.relative.field--search.w-full.mb-4
                                input.field-style#find-device-input(type="text" placeholder="Search target here (write min 3 characters)" v-model="device_keyword" @keyup="searchKeywordDevice")
                                .absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                        strong.block.text-xs.uppercase.mb-4(v-if="tactical_devices_list_map.data && tactical_devices_list_map.data.length > 0") Choose a device
                        .target-lists.block.mb-4
                            ul
                                li.flex.items-center.justify-center.border-b.p-4.text-center(v-if="load_data_status_tactical_devices_list_map === 'loading'")
                                    Spinner(show="true" size="48")

                                template(v-else-if="tactical_devices_list_map.data && tactical_devices_list_map.data.length > 0")
                                    li.flex.items-center.justify-between.border-b.p-4(v-for="(device,index) in tactical_devices_list_map.data" :key="device.id" style="cursor: pointer;" @click="selectDevice(device)")
                                        div.flex.items-center
                                            //- figure.w-6.h-6.mr-4
                                                img.w-full.h-full.object-cover.rounded-full.bg-gray-100(src="https://randomuser.me/api/portraits/women/50.jpg")
                                            span.text-light.name-index {{ device.name }}

                                li.flex.items-center.justify-center.border-b.p-4.text-center(v-else-if="tactical_devices_list_map.data && tactical_devices_list_map.data.length == 0")
                                    | No Data Available

        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Tactical Devices Lists
                    .header-cta
                        router-link.btn-primary(to="/tactical-devices/create") Add Tactical Device
            .box__body
                .form.p-4
                    .flex.flex-wrap.items-center.justify-between
                        .field.mr-0.relative.field--search.mb-3(
                            class="lg:mb-0 lg:mr-2"
                        )
                            input.field-style(id="field" type="text" v-model="keyword" placeholder="Search device here..." @keyup="searchKeyword")
                            .absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>

                        .flex.flex-wrap.items-center.w-full(
                            class="lg:w-auto"
                        )
                            span.mr-2 Show
                            .field.mr-2.relative.flex-grow
                                select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                    option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            span entries

                .table-static.w-full.p-4
                    table.table-general
                        thead
                            tr
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_tactical_devices_list === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")

                            template(v-else-if="tactical_devices_list.data && tactical_devices_list.data.length > 0")
                                tr(v-for="(device,index) in tactical_devices_list.data" :key="device.id")
                                    td
                                        //- router-link.text-link(:to="'/tactical-devices/'+device.id+'/edit'") {{ device.name }}
                                        | {{ device.name ? device.name : '-' }}
                                    td {{ device.device_id ? device.device_id : '-' }}
                                    td {{ device.users && device.users[0] && device.users[0].name ? device.users[0].name : '-' }}
                                    td {{ device.description ? (device.description.length > 16 ? device.description.substring(0, 16)+'...' : device.description) : '-' }}
                                    td.action
                                        .flex.items-center.justify-end
                                            router-link.btn-icon.btn-icon-40(:to="'/tactical-devices/'+device.id+'/edit'" v-tooltip="'Edit'")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                                                
                                            button.btn-icon.btn-icon-40(v-tooltip="'Delete'" @click="deleteData(device.id, device.name)")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            tr(v-else)
                                td.text-center(:colspan="tableThead.length") No Data Available
                    .mt-5
                    vue-ads-pagination(
                        :total-items="total_data"
                        :items-per-page="items_per_page"
                        :page="page"
                        :max-visible-pages="5"
                    )
                        template(slot="buttons" slot-scope="props")
                            vue-ads-page-button(
                                v-for="(button, key) in props.buttons"
                                :key="key"
                                v-bind="button"
                                :class="{'bg-yellow-dark': button.active}"
                                @page-change="page = button.page"
                                @range-change="start = button.start; end = button.end"
                            )

        //- .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Device's location
                    .header-cta
            .box__body
                .w-full(style="height:600px")
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3953.1738240507757!2d110.37531111477065!3d-7.771384694399184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a59b2d4729729%3A0xac4d7b5fcf34f8e4!2sGadjah%20Mada%20University!5e0!3m2!1sen!2sid!4v1591602090544!5m2!1sen!2sid" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { gmapApi } from 'vue2-google-maps';
import moment from 'moment';

// openmapstreet
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
    name: 'PageTacticalDevicesIndex',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        Loading,
        NoDataAvailable,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Tactical Devices',
                    url: '/tactical-devices',
                },
            ],

            tableThead: [
                {
                    name: 'Device Name',
                    // number: true,
                },{
                    name: 'Device ID (IMEI)',
                },{
                    name: 'User',
                },{
                    name: 'Description',
                },{
                    name: 'Action',
                    action: true,
                },
            ],

            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,

            // map
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}]
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}]
                    }
                ],
            },
            infoWindows: [],
            mapLoaded: false,
            popupShow: false,
            center: {},
            markers: [],
            // places: [],
            // heatmap: null,
            mapsLatLng: [],
            polyline: null,

            marker_color: {
                green: '#48bb78',
                red: '#f56565',
                purple: '#9f7aea',
                orange: '#ed8936',
                blue: '#4299e1',
            },

            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined || typeof process.env.VUE_APP_VENDOR_MAP!=='undefined'? process.env.VUE_APP_VENDOR_MAP: 'gmap'),

            // openmapstreet
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: [],
            idOsm: 'openstreetmap-index_tactical_device',
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),

            device_selected: {},
            device_keyword: '',
        }
    },
    computed: {
        ...mapState([
            'load_data_status_tactical_devices_list',
            'load_data_status_tactical_devices_list_map',
            'load_data_status_tactical_devices_map_location',
            'tactical_devices_list',
            'tactical_devices_list_map',
            'tactical_devices_map_location',
        ]),
        google: gmapApi,
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        google() {},
        route_name(newData, oldData) {
            if (newData === 'PageTacticalDevicesIndex') {
                if (oldData !== 'PageTacticalDevicesIndex') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setTacticalDevicesList', {});
                }

                this.getData();
            }
        },
        tactical_devices_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
        tactical_devices_map_location(newData) {
            if (newData.length > 0)
                this.startMap();
        },
    },
    methods: {
        getData(map=false) {
            if (this.route_name === 'PageTacticalDevicesIndex') {
                if (map === true) {
                    this.$store.dispatch('getTacticalDevicesList', [30, 1, this.device_keyword, null, null, null, true]);
                } else {
                    this.$store.dispatch('getTacticalDevicesList', [this.items_per_page, (parseInt(this.page) + 1), this.keyword]);

                    // if (this.tactical_devices_list.total_page && this.tactical_devices_list.total_page > 1) {
                        // console.log(this.tactical_devices_list.total_page)
                        this.pagination();
                    // }

                    this.getMapLocation();
                }
            }
        },
        getMapLocation() {
            this.$store.dispatch('getTacticalDevicesMapLocation', (this.device_selected.id ? this.device_selected.id : ''));
        },
        deleteData(id, name) {
            this.$swal.fire({
                icon: 'warning',
                // title: 'Are you sure you want to delete data?',
                title: 'Are you sure you want to delete?',
                // text: id,
                text: 'Device : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {

                if (result.isConfirmed) {

                    this.showLoading(true);

                    this.$store.dispatch('getTacticalDevicesDelete', [id])
                    .then((resp) => {
                        if (resp === 'success') {
                            this.page = 0;

                            this.getData();

                            this.$swal.fire({
                                icon: 'success',
                                title: 'Data successfully deleted!',
                                timer: 3000,
                            });
                        } else {
                            if (resp.data.message) {
                                this.error(resp.data.message);
                            } else {
                                this.error();
                            }
                        }
                    });
                }
            });
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setTacticalDevicesList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        textFocus(id) {
            document.getElementById(id).focus();
        },
        searchKeywordDevice() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setTacticalDevicesListMap', {});

                if (self.device_keyword.length > 2) {
                    self.getData(true);
                }
            }, 650);
        },
        selectDevice(device) {
            this.device_selected = device;
            this.popupShow = !this.popupShow;
            this.device_keyword = '';
            this.$store.commit('setTacticalDevicesListMap', {});
            this.getMapLocation();
        },
        setEmptyDevice() {
            this.device_selected = {};
            this.getMapLocation();
        },
        datetimeFormat(datetime) {
            // return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
            return moment(datetime, 'YYYY-MM-DD hh:mm:ss+0000').format('DD MMM YYYY HH:mm:ssZ');
        },
        hideAllInfoWindows() {
            for (var j=0; j < this.infoWindows.length; j++) {
                this.infoWindows[j].close();
            }
        },
        async startMap() {
            switch(this.vendorMap) {
              case 'osm':
                await this.startMapOSM();
                break;
              default:
                await this.startMapGMAP();
                break;
            }
        },
        async startMapOSM() {
            var self = this;

            self.locations = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                const map = self.$refs.mapRefOSM.mapObject

                if (self.tactical_devices_map_location.length > 0) {
                    var bounds = [];
                    
                    for (var i = 0; i < self.tactical_devices_map_location.length; i++) {

                        if (Object.keys(self.tactical_devices_map_location[i]).length > 0) {
                            let latTmp = parseFloat(self.tactical_devices_map_location[i].lat);
                            let lngTmp = parseFloat(self.tactical_devices_map_location[i].lng);
                            var dtm = (self.tactical_devices_map_location[i].created_at ? self.datetimeFormat(self.tactical_devices_map_location[i].created_at) : '-');
                            
                            var contentString = '<div id="content">'+
                              '<div id="bodyContent">'+
                              '<table>'+
                                  '<tr>'+
                                    '<td class="pr-1 cell-info-window whitespace-no-wrap">Device Name</td>'+
                                    '<td class="pr-1 cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.tactical_devices_map_location[i].device.name+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">User</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.tactical_devices_map_location[i].user.name+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Datetime</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+dtm+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Link Location</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.tactical_devices_map_location[i].lat+','+self.tactical_devices_map_location[i].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                    '</td>'+
                                  '</tr>'+
                                '</table>'+
                              '</div>'+
                            '</div>';

                            let centerTmp = [latTmp, lngTmp]
                            self.locations.push({
                                name: contentString,
                                position: centerTmp
                            });

                            bounds.push(centerTmp);
                        }

                    }

                    if (bounds.length){
                        map.fitBounds(L.latLngBounds([bounds]))
                    }
                }
            });
        },
        async startMapGMAP() {
            var self = this;
            // var mapsLatLng = [];

            self.infoWindows = [];
            self.markers = [];
            self.mapsLatLng = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                self.$refs.mapRef.$mapPromise.then((map) => {
                    const google = self.google;

                    // map.center = new google.maps.LatLng(self.center);

                    if (self.tactical_devices_map_location.length > 0) {
                        var bounds = new google.maps.LatLngBounds();

                        for (var i = 0; i < self.tactical_devices_map_location.length; i++) {

                            let marker = new google.maps.Marker({
                                position: {
                                    lat: parseFloat(self.tactical_devices_map_location[i].lat),
                                    lng: parseFloat(self.tactical_devices_map_location[i].lng)
                                },
                                map: map,
                                // icon: icon,
                                // draggable: true,
                            });
                            // console.log(marker);
                            self.markers.push(marker);

                            var dtm = (self.tactical_devices_map_location[i].created_at ? self.datetimeFormat(self.tactical_devices_map_location[i].created_at) : '-');
                            
                            var contentString = '<div id="content">'+
                                  '<div id="bodyContent">'+
                                  '<table>'+
                                      '<tr>'+
                                        '<td class="pr-1 cell-info-window whitespace-no-wrap">Device Name</td>'+
                                        '<td class="pr-1 cell-info-window">:</td>'+
                                        '<td class="cell-info-window">'+self.tactical_devices_map_location[i].device.name+'</td>'+
                                      '</tr>'+
                                      '<tr>'+
                                        '<td class="cell-info-window whitespace-no-wrap">User</td>'+
                                        '<td class="cell-info-window">:</td>'+
                                        '<td class="cell-info-window">'+self.tactical_devices_map_location[i].user.name+'</td>'+
                                      '</tr>'+
                                      '<tr>'+
                                        '<td class="cell-info-window whitespace-no-wrap">Datetime</td>'+
                                        '<td class="cell-info-window">:</td>'+
                                        '<td class="cell-info-window">'+dtm+'</td>'+
                                      '</tr>'+
                                      '<tr>'+
                                        '<td class="cell-info-window whitespace-no-wrap">Link Location</td>'+
                                        '<td class="cell-info-window">:</td>'+
                                        '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.tactical_devices_map_location[i].lat+','+self.tactical_devices_map_location[i].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                        '</td>'+
                                      '</tr>'+
                                    '</table>'+
                                  '</div>'+
                                  '</div>';

                            let infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                maxWidth: 400
                            });
                            
                            self.infoWindows.push(infowindow);
                            
                            google.maps.event.addListener(marker, 'click', function() {
                              // hideAllInfoWindows(map);
                              self.hideAllInfoWindows();
                              infowindow.open(map, marker);
                              // console.log(marker.position.lat(), marker.position.lng())
                            });

                            bounds.extend(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
                        }
                        // Apply fitBounds
                        map.fitBounds(bounds); 
                    }
                });
            });
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">
    .action--three
        width: 160px
</style>
